import { render } from "./PageCounter.vue?vue&type=template&id=2fbc7c86&scoped=true"
import script from "./PageCounter.vue?vue&type=script&lang=js"
export * from "./PageCounter.vue?vue&type=script&lang=js"

import "./PageCounter.vue?vue&type=style&index=0&id=2fbc7c86&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbc7c86"]])

export default __exports__